































import Super from '@/Super';
import { Component } from 'vue-property-decorator';
import OverflowResizer from '@/components/OverflowResizer.vue';
import { State } from '@/vuex-decorators';
import { Hotspot, HotspotNames, hotspots } from '@/data/hotspots';
import { productResources } from '@/data/resources';

@Component({
  components: {
    OverflowResizer
  }
})
export default class Home extends Super {
  @State() viewingRequestMeeting!: boolean;
  @State() viewingMedicalInformation!: boolean;

  overflowResizerData = {
    image: require('../assets/images/booth-lg.png'),
    top: 1841,
    left: 3421,
    width: 5022,
    height: 2319
  };

  handleHotspotClick(name: string) {
    switch (name) {
      case HotspotNames.ProductResources:
        this.openProductResources();
        break;
      case HotspotNames.RequestMeeting:
        this.viewingRequestMeeting = true;
        break;
      case HotspotNames.ExpertChallengeBillboard:
      case HotspotNames.ExpertChallenge:
        this.openChallenge();
        break;
      case HotspotNames.VideoResources:
        this.openVideoLibrary();
        break;
      case HotspotNames.MedicalInformation:
        this.viewingMedicalInformation = true;
        break;
      case HotspotNames.PDFLeft:
        this.openPDF('Latuda Efficacy Brochure', './pdfs/LATUDA-Efficacy-Brochure.pdf');
        break;
      case HotspotNames.PDFMiddle:
        this.openPDF('Patient Profile - <em>Lottie</em>', './pdfs/Patient-Profile---Lottie.pdf');
        break;
      case HotspotNames.PDFRight:
        this.openPDF('HCP PREVAIL I & II Reprint', './pdfs/HCP-PREVAIL-I-&-II-Reprint.pdf');
        break;
    }
  }

  getHotspotStyle(hotspot: Hotspot) {
    return {
      top: hotspot.top + 'px',
      left: hotspot.left + 'px',
      width: hotspot.width + 'px',
      height: hotspot.height + 'px',
      transform: hotspot.transform || ''
    };
  }

  get hotspots() {
    return hotspots;
  }
}
